import { useLicenseContext } from '../lib/LicenseContext';
import Link from './Link';

export default function Pricing() {
  const { isPro, startCheckout } = useLicenseContext();
  return (
    <section id="pricing" className="pricing-section">
      <div className="container">
        <h2 className="section-title">Simple, Transparent Pricing</h2>
        <p className="section-description">Choose the plan that fits your needs</p>
        
        <div className="pricing-grid">
          <div className="pricing-card">
            <div className="pricing-header">
              <h3 className="pricing-title">Free</h3>
              <div className="pricing-price">$0</div>
              <div className="pricing-period">forever</div>
            </div>
            <ul className="pricing-features">
              <li>Up to 20 rows per batch</li>
              <li>SVG export only</li>
              <li>Basic QR designs</li>
              <li>No logos or label sheets</li>
              <li>Ads enabled</li>
            </ul>
            <div className="pricing-cta">
              <Link to="/app" className="btn btn-outline btn-lg w-full">Try Free</Link>
            </div>
          </div>
          
          <div className="pricing-card pricing-card-featured">
            <div className="pricing-badge">Popular</div>
            <div className="pricing-header">
              <h3 className="pricing-title">Pro</h3>
              <div className="pricing-price">$27</div>
              <div className="pricing-period">one-time payment – Lifetime Pro Access</div>
            </div>
            <ul className="pricing-features">
              <li>Unlimited CSV rows</li>
              <li>PNG & SVG export</li>
              <li>Center logo overlay</li>
              <li>Label sheet builder (PDF)</li>
              <li>Custom colors & shapes</li>
              <li>Priority rendering speed</li>
              <li>Ad-free experience</li>
            </ul>
            <div className="pricing-cta">
              {isPro ? (
                <Link to="/app" className="btn btn-primary btn-lg w-full">Pro Active - Open App</Link>
              ) : (
                <button onClick={startCheckout} className="btn btn-primary btn-lg w-full">
                  Unlock Pro for $27
                </button>
              )}
            </div>
          </div>
        </div>
        
        <div style={{ textAlign: 'center', marginTop: '2rem', paddingTop: '0.5rem' }}>
          <p style={{ textAlign: 'center' }}>No subscriptions. No hidden fees. Pay once, own it forever.</p>
          <p style={{ textAlign: 'center' }} className="mt-2 text-sm text-slate-600 dark:text-slate-400">Includes free updates and current Pro features for life.</p>
        </div>
      </div>
    </section>
  );
}
